module.exports = __webpack_public_path__ + "media/bootstrap-icons/bootstrap-743947af.svg";